import { FieldRenderProps } from '@progress/kendo-react-form';

import styles from './TextFormField.module.scss';

export const TextFormField = (fieldRenderProps: FieldRenderProps) => {
  const { label, value, onChange, title } = fieldRenderProps;

  return (
    <div className='k-form-field'>
      <label htmlFor='#' className='k-label'>
        {label}
      </label>
      <div className='k-form-field-wrap' title={title}>
        <span className={`k-input k-input-md k-rounded-md ${styles.field}`} onChange={onChange}>
          {value ? value : 'N/A'}
        </span>
      </div>
    </div>
  );
};
